import Vue from 'vue'
import * as jsonpatch from 'fast-json-patch/index.mjs'

const luState = {
  state: {
    luStates: [],
    selectedLuState: {},
    selectedLuStateOriginal: {},
    saving: false,
    searchCount: 0,
  },

  getters: {
    luStates(state) {
      return state.luStates
    },
    selectedLuState(state) {
      return state.selectedLuState
    },
    selectedLuStateOriginal(state) {
      return state.selectedLuStateOriginal
    },
    loading(state) {
      return state.searchCount > 0
    },
  },

  mutations: {
    luStates(state, payload) {
      state.luStates = payload
    },
    selectedLuState(state, payload) {
      state.selectedLuState = JSON.parse(JSON.stringify(payload))
    },
    selectedLuStateOriginal(state, payload) {
      state.selectedLuStateOriginal = JSON.parse(JSON.stringify(payload))
    },
    saving(state, payload) {
      state.saving = payload
    },
    searchCount(state, payload) {
      state.searchCount = payload
    },
    increaseSearchCount(state, payload) {
      state.searchCount = state.searchCount + 1
    },
    decreaseSearchCount(state, payload) {
      state.searchCount = state.searchCount - 1
    },
  },

  actions: {
    setSelectedLuState(context, payload) {
      context.commit('selectedLuState', payload)
    },
    async loadLuStates(context, payload) {
      const url = 'LuState'
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('luStates', res.data)
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    refreshSelectedLuState(context, payload) {
      if (context.state.selectedLuState && context.state.selectedLuState.Id > 0) {
        context.dispatch('loadSelectedLuState', context.state.selectedLuState.Id)

      }
    },
    async loadSelectedLuState(context, payload) {
      if (context.state.selectedLuState && context.state.selectedLuState.Id != payload) {
        context.commit('selectedLuState', {})
      }
      const url = 'LuState/' + payload
      context.commit('increaseSearchCount')
      try {
        let res = await Vue.prototype.$axios.get(url)
        context.commit('selectedLuState', res.data)
        context.commit('selectedLuStateOriginal', res.data)
        context.commit('decreaseSearchCount')
        return res
      } catch (err) {
        console.error(err)
        context.commit('decreaseSearchCount')
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    clearLookupCacheAndReloadLuStates(context, payload) {
      caches.delete('apilookup-cache').finally(() => {
          context.dispatch('loadLuStates')
      }, )
    },
    async createLuState(context, payload){
      const url = `LuState`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios.post(url, payload)
        context.dispatch('messages/toastMessage',
        {color: 'success', message: 'state created',},{ root: true })
        //if you will always need to reload the list after an item is created
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadLuStates')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async patchLuState(context, payload){
      var item = context.state.selectedLuState
      if (payload.Id && 
      payload.Id == context.state.selectedLuStateOriginal.Id)  {
      item = payload
      }
      var patchPayload = {}
      if (!payload.patchDoc || !payload.Id) {
        let original = context.state.selectedLuStateOriginal
        let current = item
        patchPayload.Id = item.Id
        var diff = jsonpatch.compare(
              original,
              current
            )
        patchPayload.patchDoc = diff

      } else {
        patchPayload = payload
      }
      if (patchPayload.patchDoc.length > 0) {
        const url = `LuState/${ patchPayload.Id }`
        context.commit('saving', true)
        try {
          let res = await Vue.prototype.$axios
          .patch(url, patchPayload.patchDoc)
          context.dispatch('messages/toastMessage',
          {color: 'success', message: 'state updated',},{ root: true })
          //if you will always need to reload the list after an update
          //you can uncomment out the following dispatch line.
          //Alternatively you can reload whatever object you need
          //when the promise resolves in the component that called it.
          //context.dispatch('loadLuStates')
          context.commit('saving', false)
          return res
        } catch (err) {
          console.error(err)
          context.commit('saving', false)
          context.dispatch('errors/handleError', err, { root: true })
          throw err
        }
      } else {
        return 'no changes'
      }
    },
    async updateLuState(context, payload){
      const url = `LuState/${ payload.Id }`
      context.commit('saving', true)
      try {
        let res = await Vue.prototype.$axios
          .put(url, payload)
        context.dispatch('messages/toastMessage',
        {color: 'success', message: 'state updated',},{ root: true })
        //if you will always need to reload the list after an update
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadLuStates')
        context.commit('saving', false)
        return res
      } catch (err) {
        console.error(err)
        context.commit('saving', false)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
    async saveLuState(context, payload){
      if (payload.Id > 0) {
        return context.dispatch('updateLuState', payload)
      } else {
        return context.dispatch('createLuState', payload)
      }
    },
    async deleteLuState(context, payload){
      const url = `LuState/${ payload.Id }`
      try {
        let res = await Vue.prototype.$axios.delete(url)
        context.dispatch('messages/toastMessage',
        {color: 'success', message: 'state deleted',},{ root: true })
        //if you will always need to reload the list after a delete
        //you can uncomment out the following dispatch line.
        //Alternatively you can reload whatever object you need
        //when the promise resolves in the component that called it.
        //context.dispatch('loadLuStates')
        return res
      } catch (err) {
        console.error(err)
        context.dispatch('errors/handleError', err, { root: true })
        throw err
      }
    },
  },
}

export default luState